import { createSelector } from 'reselect';
import { SettingsStore } from '@modules/settings/types/store';

export const diffSettingsSelector = createSelector(
  (state: SettingsStore) => state.fixed.Settings.diffSettings,
  (diffSettings) => diffSettings
);
